export default "../img/arrow-left.svg";